export const tcPromotionAAD = [
  {
    tag: "1.",
    content:
      "Apabila seorang calon AAD mempunyai satu atau lebih Agen <b>rekrutan langsung</b> yang juga mengajukan promosi AAD pada saat bersamaan, maka produksi pribadi Agen-agen rekrutan tersebut <b>dapat diperhitungkan</b> sebagai <b>Total Produksi Calon AAD</b>. Agen-agen rekrutan langsung tersebut juga dapat diperhitungkan untuk <b>total Agen Aktif atau Agen Aktif baru</b> calon AAD sebagai persyaratan promosi.",
  },
  {
    tag: "2.",
    content:
      "Jika terdapat lebih dari satu pengajuan promosi menjadi AAD dengan menggunakan satu Agen Aktif atau Agen Aktif baru yang sama, maka <b>perekrut langsung</b> yang berhak menggunakan Agen Aktif tersebut untuk persyaratan promosi.",
  },
  {
    tag: "3.",
    content:
      "Bagi Agen Aktif atau Agen Aktif baru yang direkrut secara tidak langsung hanya dapat digunakan oleh satu orang Agen untuk persyaratan promosi AAD dengan catatan Agen Aktif tersebut tidak mengajukan promosi secara bersamaan menjadi AAD.",
  },
];

export const tcPkConventionalPage1To18 = [
  {
    content: "Definisi",
    tag: "1.",
    child: [
      {
        tag: "1.1",
        content:
          "Dalam Perjanjian ini, kecuali apabila konteksnya secara tegas menyatakan atau mensyaratkan lain, maka kata-kata sebagaimana dimaksud di bawah ini memiliki arti sebagai berikut:",
        child: [
          {
            tag: "1.1.1",
            content: "<b>”AAJI”</b> adalah Asosiasi Asuransi Jiwa Indonesia.",
          },
          {
            tag: "1.1.2",
            content:
              "<b>”Cacat Total dan Tetap”</b> adalah cacat sebagai akibat dari Kecelakaan atau penyakit yang menyebabkan:",
            content2:
              "Sedangkan ”Kecelakaan” merupakan peristiwa yang tidak diharapkan, terjadi secara tiba-tiba, tidak terduga, tidak disengaja, datangnya dari luar, bersifat kekerasan dan kasat mata.",
            child: [
              {
                tag: "a.",
                content:
                  "Agen sama sekali tidak dapat melakukan pekerjaan apa pun untuk mencari nafkah secara terus-menerus selama 180 hari terakhir sejak didiagnosa oleh dokter, tidak termasuk cacat berupa kelainan jiwa, cacat mental, neurosis, psikosomatis ataupun psikosis; atau",
              },
              {
                tag: "b.",
                content:
                  "Agen kehilangan fungsi secara total dan tidak dapat dipulihkan atas anggota tubuh sebagai berikut:",
                child: [
                  {
                    tag: "(1)",
                    isTagNumber: true,
                    content: "Kedua mata, atau",
                  },
                  {
                    tag: "(2)",
                    isTagNumber: true,
                    content:
                      "Kedua lengan atau kedua kaki atau satu lengan dan satu kaki yang terjadi pada atau di atas pergelangan tangan atau pergelangan kaki, atau",
                  },
                  {
                    tag: "(3)",
                    isTagNumber: true,
                    content:
                      "Satu mata dan satu lengan yang terjadi pada atau di atas pergelangan tangan, atau",
                  },
                  {
                    tag: "(4)",
                    isTagNumber: true,
                    content:
                      "Satu mata dan satu kaki yang terjadi pada atau di atas pergelangan kaki.",
                  },
                ],
              },
            ],
          },
          {
            tag: "1.1.3",
            content: "<b>”Evaluasi”</b> adalah sebagaimana didefinisikan dalam Pasal 6.",
          },
          {
            tag: "1.1.4",
            content:
              "<b>“Informasi Rahasia”</b> adalah segala informasi rahasia mengenai Perusahaan dan Kelompok Usaha-nya dari waktu ke waktu (dalam bentuk apapun) termasuk tetapi tidak terbatas pada segala informasi mengenai bisnis, keuangan, operasional, nasabah dan <i>marketing, know-how</i> dan rahasia dagang sehubungan dengan bisnis dari Perusahaan dan Kelompok Usaha-nya tersebut dan segala informasi di mana Perusahaan dan Kelompok Usaha-nya terikat untuk menjaga kerahasiaan informasi tersebut ke pihak ketiga.",
          },
          {
            tag: "1.1.5",
            content:
              "<b>“Kelompok Usaha”</b> adalah berarti setiap perusahaan di mana Prudential plc dan/atau afiliasinya menjadi pemegang saham utamanya.",
          },
          {
            tag: "1.1.6",
            content:
              "<b>“Jasa”</b> adalah seluruh jasa yang diberikan oleh Agen kepada Nasabah dan kewajiban yang harus dilakukan Agen berdasarkan Perjanjian ini, termasuk hal-hal sebagaimana diatur dalam Pasal 3.",
          },
          {
            tag: "1.1.7",
            content:
              "<b>“Kekayaan Intelektual”</b> adalah setiap hak paten, hak cipta, hak merek, rahasia dagang, hasil karya, desain, metode, teknik, proses, prosedur, ilustrasi, baik terdaftar maupun tidak, baik dalam bentuk cetak, audio atau video, yang dimiliki dan/atau dibuat oleh Perusahaan.",
          },
          {
            tag: "1.1.8",
            content:
              "<b>“Kerugian”</b> adalah setiap klaim, tanggung jawab, pengeluaran, denda, biaya keterlambatan, penalti, biaya, kerugian dalam bentuk apapun (termasuk biaya hukum).",
          },
          {
            tag: "1.1.9",
            content:
              "<b>“Ketentuan Komisi”</b> adalah ketentuan mengenai Komisi (sebagaimana didefinisikan di bawah ini) yang berhak diterima oleh Agen berdasarkan Perjanjian ini, sebagaimana terlampir dalam Lampiran I beserta segala perubahannya dari waktu ke waktu.",
          },
          {
            tag: "1.1.10",
            content:
              "<b>“Kode Etik Tenaga Pemasar”</b> adalah Standar Praktik dan Kode Etik Tenaga Pemasar Asuransi Jiwa sebagaimana yang diuraikan dalam Lampiran III beserta segala perubahannya dari waktu ke waktu.",
          },
          {
            tag: "1.1.11",
            content:
              "<b>“Komisi”</b> adalah komisi yang berhak diterima Agen sebagaimana diuraikan dalam Pasal 4.",
          },
          {
            tag: "1.1.12",
            content:
              "<b>“Logo Perusahaan”</b> adalah semua nama, tanda-tanda, merek dagang, dan/atau logo Perusahaan.",
          },
          {
            tag: "1.1.13",
            content:
              "<b>“Nasabah”</b> adalah semua orang yang sudah dan/atau berpotensi menjadi pemegang polis Perusahaan.",
          },
          {
            tag: "1.1.14",
            content: "<b>“OJK”</b> adalah Otoritas Jasa Keuangan Republik Indonesia.",
          },
          {
            tag: "1.1.15",
            content:
              "<b>“Penangguhan”</b> adalah salah satu bentuk Tindakan Disiplin yang dapat diberikan oleh Perusahaan kepada Agen berupa penangguhan sebagian atau seluruh hak Agen sebagaimana diatur di dalam Pasal 8.",
          },
          {
            tag: "1.1.16",
            content:
              "<b>“Peraturan AAJI”</b> adalah peraturan dan kebijakan yang dikeluarkan oleh AAJI beserta segala penambahan dan perubahannya.",
          },
          {
            tag: "1.1.17",
            content:
              "<b>“Peraturan Keagenan”</b> adalah semua peraturan dan kebijakan yang dikeluarkan dan/atau disosialisasikan oleh Perusahaan dari waktu ke waktu, termasuk namun tidak terbatas pada PRU Berita, Kode Etik Keagenan, <i>agency update</i>, Panduan Komunikasi dan penggunaan merek untuk Tenaga Pemasar dan <i>operational update, flyer</i> beserta segala penambahan dan perubahannya dari waktu ke waktu.",
          },
          {
            tag: "1.1.18",
            content:
              "<b>“Produk Asuransi”</b> adalah program asuransi jiwa konvensional yang ditawarkan dan/atau dipertanggungkan oleh Perusahaan, serta semua program asuransi lainnya yang disetujui dan diterbitkan oleh Perusahaan dari waktu ke waktu.",
          },
          {
            tag: "1.1.19",
            content:
              "<b>“Prudential Syariah”</b> yaitu PT Prudential Sharia Life Assurance, sebuah perusahaan yang memiliki ijin untuk menjalankan bisnis asuransi jiwa berbasis syariah, serta merupakan anak perusahaan dari Perusahaan.",
          },
          {
            tag: "1.1.20",
            content:
              "<b>“SPAJ”</b> adalah aplikasi Surat Pengajuan Asuransi Jiwa yang ditentukan oleh Perusahaan dari waktu ke waktu.",
          },
          {
            tag: "1.1.21",
            content: "<b>“Tindakan Disiplin”</b> adalah sebagaimana didefinisikan dalam Pasal 8.",
          },
        ],
      },

      {
        tag: "1.2",
        content:
          "Judul dan sub judul dalam Perjanjian ini adalah untuk memudahkan saja dan tidak mempengaruhi implementasi atau penafsiran atas Perjanjian ini.",
      },
      {
        tag: "1.3",
        content: "Kecuali ditentukan lain, dalam Perjanjian ini:",
        child: [
          {
            tag: "1.3.1",
            content:
              "Kata dengan bentuk tunggal mencakup juga bentuk jamak, demikian pula sebaliknya;",
          },
          {
            tag: "1.3.2",
            content:
              "Referensi yang menunjuk pada Klausul, Pasal, Ayat, dan Lampiran berarti menunjuk pada klausul, pasal, ayat dan lampiran Perjanjian ini; dan",
          },
          {
            tag: "1.3.3",
            content:
              "Referensi yang menunjuk kepada suatu orang akan dianggap sebagai referensi terhadap para penerus dan pengganti haknya yang sah.",
          },
        ],
      },
    ],
  },
  {
    tag: "2.",
    content: "Penunjukan Agen",
    subContent:
      "Perusahaan dengan ini menunjuk dan memberi wewenang kepada Agen untuk memberikan Jasa di wilayah negara Republik Indonesia dengan tunduk kepada syarat-syarat dan ketentuan-ketentuan dalam Perjanjian ini.",
  },
  {
    tag: "3.",
    content: "Kewajiban dan Tanggung Jawab Agen",
    child: [
      {
        tag: "3.1",
        content:
          "Agen wajib memiliki sertifikasi dan lisensi keagenan sebagaimana disyaratkan peraturan dan perundang-undangan yang berlaku.",
      },
      {
        tag: "3.2",
        content:
          "Agen wajib untuk mempergunakan waktu dan perhatiannya untuk melakukan hal-hal di bawah ini dengan baik: ",
        child: [
          {
            tag: "3.2.1",
            content:
              "Mempromosikan, memasarkan dan menjual Produk Asuransi kepada Nasabah dan melayani pertanyaan dari Nasabah mengenai Produk Asuransi;",
          },
          {
            tag: "3.2.2",
            content:
              "Mencari dan menghubungi Nasabah atas nama Perusahaan, dan memberikan layanan purna jual kepada Nasabah tersebut;",
          },
          {
            tag: "3.2.3",
            content:
              "Mengumpulkan dan memberikan seluruh informasi mengenai Nasabah kepada Perusahaan, serta mempersiapkan dokumen baik dokumen fisik maupun digital dan laporan yang dibutuhkan, termasuk namun tidak terbatas pada dokumen-dokumen sehubungan dengan pengajuan atau perubahan polis Perusahaan; dan",
          },
          {
            tag: "3.2.4",
            content:
              "Melakukan dan menyelesaikan tugas-tugas, kewajiban-kewajiban, hal-hal, fungsi-fungsi yang ditugaskan kepada Agen oleh Perusahaan dari waktu ke waktu.",
          },
        ],
      },
      {
        tag: "3.3",
        content:
          "Apabila Agen memberikan aplikasi Produk Asuransi atau dokumen-dokumen lain sehubungan dengan Nasabah kepada Perusahaan, maka Agen akan dianggap menyatakan dan menjamin Perusahaan bahwa:",
        child: [
          {
            tag: "3.3.1",
            content:
              "Agen telah melakukan verifikasi atas seluruh detil informasi yang dirujuk, tertera atau disertakan dalam aplikasi Nasabah tersebut dan bahwa informasi tersebut adalah benar, lengkap dan akurat serta tanda tangan yang tertera dalam aplikasi tersebut adalah tanda tangan asli Nasabah; dan",
          },
          {
            tag: "3.3.2",
            content:
              "Dokumen-dokumen pendukung yang disertakan dalam aplikasi Nasabah tersebut adalah merupakan dokumen asli, atau bilamana dalam bentuk fotokopi/digital maka fotokopi/digital tersebut memuat data-data yang sama dengan dokumen aslinya dan tanda tangan yang tertera dalam aplikasi dan dokumen-dokumen tersebut adalah tanda tangan asli Nasabah.",
          },
        ],
      },
      {
        tag: "3.4",
        content: "Agen wajib untuk setiap saat dan dalam segala hal patuh dan tunduk terhadap:",
        child: [
          {
            tag: "3.4.1",
            content:
              "Setiap dan seluruh strategi, pedoman, perintah dan prosedur yang ditetapkan oleh Perusahaan dari waktu ke waktu sehubungan dengan kinerja Agen;",
          },
          {
            tag: "3.4.2",
            content:
              "Peraturan Keagenan, Peraturan AAJI, Peraturan OJK dan berpartisipasi dalam setiap pelatihan-pelatihan, sosialisasi produk dan program-program kepatuhan (baik diadakan oleh Perusahaan maupun pihak lain) yang disyaratkan oleh Perusahaan; dan",
          },
          {
            tag: "3.4.3",
            content:
              "Seluruh peraturan dan perundang-undangan yang berlaku terhadap Agen, dan wajib memastikan bahwa Jasa dilakukan dalam cara yang tidak (i) melanggar peraturan dan perundang-undangan yang berlaku di Indonesia atau (ii) yang menurut pendapat Perusahaan dapat merusak reputasi Perusahaan.",
          },
        ],
      },
      {
        tag: "3.5",
        content:
          "Agen wajib untuk melaksanakan Jasa secara kompeten dan baik serta wajib bertindak semata-mata untuk kepentingan Perusahaan dan Nasabah.",
      },
      {
        tag: "3.6",
        content: "Dalam memberikan Jasa, Agen wajib untuk setiap saat:",
        child: [
          {
            tag: "3.6.1",
            content:
              "Bertindak jujur dan penuh integritas dengan menyampaikan identitas sebagai wakil yang sah dari Perusahaan dengan menunjukkan Lisensi Keagenan yang masih berlaku, baik lisensi Keagenan yang dikeluarkan oleh AAJI",
          },
          {
            tag: "3.6.2",
            content:
              "Bertindak dengan niat baik dan meletakkan kepentingan Nasabah di atas kepentingan Agen;",
          },
          {
            tag: "3.6.3",
            content:
              "Memberikan informasi yang benar dan akurat mengenai Produk Asuransi termasuk informasi penting terkait dengan syarat dan ketentuan Polis kepada Nasabah;",
          },
          {
            tag: "3.6.4",
            content:
              "Mempertahankan agar polis-polis Produk Asuransi tetap berlaku (menjaga persistensi Nasabah);",
          },
          {
            tag: "3.6.5",
            content:
              "Memastikan bahwa kesehatan Nasabah diperiksa oleh pemeriksa kesehatan yang telah ditunjuk oleh Perusahaan, kecuali dalam hal tidak ada pemeriksa kesehatan yang ditunjuk Perusahaan di daerah tersebut;",
          },
          {
            tag: "3.6.6",
            content:
              "Mengusahakan agar Nasabah membayar semua premi secara langsung ke Perusahaan melalui bank yang ditunjuk oleh Perusahaan atau metode pembayaran yang telah disediakan Perusahaan yang diatur oleh Perusahaan dari waktu ke waktu;",
          },
          {
            tag: "3.6.7",
            content:
              "Mengirimkan Surat Pengajuan Asuransi Jiwa yang lengkap dalam jangka waktu (i) 2 (dua) hari kerja terhitung sejak Agen menerima Surat Pengajuan Asuransi Jiwa dari Nasabah untuk Surat Pengajuan Asuransi Jiwa dalam bentuk cetak; atau (ii) sesegera mungkin (namun tidak lebih dari 2 (dua) hari kerja) terhitung sejak Nasabah melengkapi Surat Pengajuan Asuransi Jiwa dalam bentuk digital;",
          },
          {
            tag: "3.6.8",
            content:
              "Meneruskan setiap dan seluruh keluhan (<i>complaint</i>) tertulis Nasabah kepada Perusahaan selambat-lambatnya dalam jangka waktu 2 x 24 jam terhitung sejak Agen menerima keluhan tersebut; dan",
          },
          {
            tag: "3.6.9",
            content:
              "Melaporkan secara tertulis setiap dan seluruh klaim untuk manfaat Produk Asuransi kepada Perusahaan secepatnya, namun tidak lebih dari 2 X 24 jam terhitung sejak diterimanya pemberitahuan klaim dari Nasabah dan/atau wakilnya.",
          },
          {
            tag: "3.6.10",
            content:
              "Memastikan untuk menggunakan materi pemasaran dan ilustrasi yang terbaru yang dikeluarkan oleh Perusahaan.",
          },
        ],
      },
      {
        tag: "3.7",
        content: "Agen dilarang untuk:",
        child: [
          {
            tag: "3.7.1",
            content:
              "Memberikan informasi dan/atau pernyataan yang salah, tidak lengkap atau menyesatkan mengenai Produk Asuransi;",
          },
          {
            tag: "3.7.2",
            content: "Memasarkan Produk Asuransi Perusahaan di luar wilayah Republik Indonesia;",
          },
          {
            tag: "3.7.3",
            content:
              "Membuat, menggunakan dan memperbanyak brosur penjualan, bahan atau materi pemasaran apapun selain yang dikeluarkan resmi oleh Perusahaan dan merupakan bagian dari Kekayaan Intelektual Perusahaan atau mengikutsertakan nama Perusahaan kecuali telah mendapat izin tertulis terlebih dahulu dari Perusahaan;",
          },
          {
            tag: "3.7.4",
            content:
              "Membuat perjanjian (dalam bentuk apa pun) dengan pihak ketiga atas nama Perusahaan;",
          },
          {
            tag: "3.7.5",
            content:
              "Melakukan perubahan terhadap ilustrasi Produk Asuransi Perusahaan dan/atau dengan cara apapun memanipulasi perangkat lunak untuk tujuan apapun;",
          },
          {
            tag: "3.7.6",
            content:
              "Kecuali ditentukan lain dalam Peraturan Keagenan, memberikan, atau mencoba memberikan, baik secara langsung maupun tidak langsung, potongan terhadap premi Produk Asuransi, atau memberikan manfaat tambahan yang tidak diatur dalam Produk Asuransi atau memberikan jaminan nilai manfaat dalam rangka membujuk Nasabah untuk menutup Produk Asuransi;",
          },
          {
            tag: "3.7.7",
            content:
              "Tanpa persetujuan tertulis sebelumnya dari Perusahaan (i) membuat, menerbitkan, membagikan, mengedarkan dalam bentuk cetak maupun elektronik atas iklan-iklan, surat-surat, brosur penjualan, bahan pemasaran, (ii) mengirimkan atau menyediakan suatu berita atau informasi, (iii) memasang iklan dalam suatu penerbitan baik cetak maupun elektronik mengenai Produk Asuransi dan/atau Perusahaan, baik atas nama sendiri maupun atas nama Perusahaan.",
          },
          {
            tag: "3.7.8",
            content:
              "Menggunakan barang, materi, atau fasilitas milik atau yang disediakan oleh Perusahaan untuk suatu maksud selain pemberian Jasa; dan",
          },
          {
            tag: "3.7.9",
            content:
              "Membayarkan premi Nasabah terlebih dahulu dan/atau membiayai premi Nasabah baik secara tunai, <i>cheque</i>/Bilyet Giro (BG), transfer atau dengan cara pembayaran lainnya, termasuk juga membayarkan premi Nasabah dengan menggunakan kartu kredit milik Agen.",
          },
          {
            tag: "3.7.10",
            content:
              "Secara langsung atau tidak langsung, dan dalam kapasitas apa pun, baik atas namanya sendiri maupun atas nama atau yang berhubungan dengan orang lain, terlibat atau melakukan pekerjaan/tugas rangkap dalam setiap kegiatan bisnis asuransi jiwa, baik secara non syariah maupun syariah, atau bisnis lain yang berkompetisi dengan Perusahaan baik secara legal atau illegal atau mengganggu dan/atau merugikan bisnis Perusahaan baik dengan menggunakan maupun tidak menggunakan jaringan pemasaran keagenan dan/atau nasabah Perusahaan.",
          },
        ],
      },
    ],
  },

  {
    tag: "4.",
    content: "Komisi Agen",
    child: [
      {
        tag: "4.1",
        content:
          "Dengan mempertimbangkan kinerja Agen dalam melakukan Jasa, dan selama masa berlakunya Perjanjian ini, Perusahaan akan memberikan Komisi kepada Agen atas Produk Asuransi yang berhasil diterbitkan dan pembayaran preminya telah diterima dan berhasil diidentifikasi oleh Perusahaan, dengan ketentuan bahwa penerbitan polis tersebut telah dilakukan sesuai dengan syarat dan ketentuan dalam Perjanjian ini dan Peraturan Keagenan.",
      },
      {
        tag: "4.2",
        content:
          "Komisi yang berhak diterima Agen akan dihitung berdasarkan syarat dan ketentuan dalam Ketentuan Komisi, dan ketentuan lain yang ditentukan oleh Perusahaan dari waktu ke waktu.",
      },
      {
        tag: "4.3",
        content:
          "Dalam hal terjadi perbedaan perhitungan Komisi antara Agen dan Perusahaan, maka perhitungan yang akan berlaku adalah perhitungan yang dilakukan oleh Perusahaan.",
      },
      {
        tag: "4.4",
        content:
          "Selain sebagaimana telah diatur dengan jelas dalam Pasal ini, Agen tidak berhak atas remunerasi, pembayaran, penggantian, ganti rugi atau kompensasi dari Perusahaan sehubungan dengan pelaksanaan Perjanjian ini. Untuk menghindarkan keragu-raguan, Agen wajib untuk membayar dan bertanggung jawab atas segala biaya, pengeluaran, termasuk namun tidak terbatas pada biaya korespondensi, akomodasi, dan biaya-biaya lain dalam bentuk apapun sehubungan dengan atau yang diperlukan oleh Agen untuk melakukan Jasa.",
      },
      {
        tag: "4.5",
        content:
          "Dalam hal Perusahaan mengembalikan premi kepada Nasabah (dengan sebab apapun), Agen wajib untuk mengembalikan setiap Komisi, insentif, kompensasi dan pendapatan lainnya dalam bentuk apapun yang telah diterima kepada Perusahaan sehubungan dengan pengembalian premi tersebut dan untuk itu Perusahaan juga berhak untuk melakukan pemotongan langsung terhadap Komisi, insentif, kompensasi dan pendapatan lainnya dalam bentuk apapun tersebut (<i>clawback</i>).",
      },
      {
        tag: "4.6",
        content:
          "Perusahaan berhak untuk menahan, mengubah atau tidak membayarkan, Komisi, insentif, kompensasi dan pendapatan lainnya dalam bentuk apapun berdasarkan Perjanjian ini, lampiran-lampirannya, dan Peraturan Keagenan apabila:",
        child: [
          {
            tag: "4.6.1",
            content:
              "menurut pendapat Perusahaan, hal tersebut diperlukan untuk mematuhi peraturan perundangan yang berlaku di Indonesia; dan/atau",
          },
          {
            tag: "4.6.2",
            content: "Agen tidak memenuhi ketentuan Pasal 10.5.",
          },
        ],
        content2:
          "dan dalam hal demikian Agen tidak berhak untuk mengajukan tuntutan atau gugatan apa pun kepada Perusahaan sehubungan dengan kerugian Agen akibat pelaksanaan Pasal 4.6 ini.",
      },
      {
        tag: "4.7",
        content:
          "Perusahaan berhak meminta Agen untuk mengembalikan jumlah yang sudah dibayarkan kepada Agen dengan cara yang tidak sesuai peraturan perundang-undangan yang berlaku tersebut.",
      },
      {
        tag: "4.8",
        content:
          "Dalam hal Agen memiliki Perjanjian Keagenan dengan Prudential Syariah, maka Perusahaan berhak untuk menahan, melakukan pemotongan langsung, mengubah atau tidak membayarkan Komisi, insentif, kompensasi dan/atau pendapatan lainnya dalam bentuk apapun berdasarkan Perjanjian ini atau Peraturan Keagenan apabila terdapat kewajiban dan/atau piutang Agen yang telah jatuh tempo dan dapat ditagih kepada Prudential Syariah.",
      },
      {
        tag: "4.9",
        content: "Untuk maksud hal-hal di bawah ini:",
        child: [
          {
            tag: "4.9.1",
            content:
              "Agen mempunyai kewajiban yang telah jatuh tempo dan dapat ditagih kepada Perusahaan, termasuk kewajiban sebagaimana diatur dalam Pasal 4;",
          },
          {
            tag: "4.9.2",
            content: "Kondisi sebagaimana diatur dalam Pasal 4.5 terjadi;",
          },
          {
            tag: "4.9.3",
            content: "Kondisi sebagaimana diatur dalam Pasal 4.6 dan/atau Pasal 4.7 terjadi;",
          },
          {
            tag: "4.9.4",
            content: "Kondisi sebagaimana diatur dalam Pasal 4.8 terjadi; dan/atau",
          },
          {
            tag: "4.9.5",
            content: "Kondisi sebagaimana diatur dalam Pasal 9.2 terjadi,",
          },
        ],
        content2:
          "Agen dengan ini memberikan kuasa kepada Perusahaan untuk memotong Komisi, insentif, kompensasi dan/atau pendapatan lainnya dalam bentuk apapun berdasarkan Perjanjian ini, lampiran-lampirannya, dan/atau Peraturan Keagenan. Dalam hal pemotongan Komisi, insentif, kompensasi dan/atau pendapatan lainnya dalam bentuk apapun tidak cukup untuk mengembalikan Komisi, insentif, kompensasi, pendapatan lainnya tersebut dan/atau kewajiban finansial lainnya, maka Perusahaan akan memberitahu Agen secara tertulis dan Agen wajib dengan segera, namun tidak lebih dari 2 (dua) hari kerja setelah pemberitahuan tertulis dari Perusahaan, membayar jumlah yang diminta tersebut kepada Perusahaan secara sekaligus.",
      },
    ],
  },
  {
    tag: "5.",
    content: "Pernyataan Dan Jaminan",
    subContent: "Agen dengan ini menyatakan dan menjamin bahwa:",
    child: [
      {
        tag: "5.1",
        content:
          "Agen berwenang membuat, menandatangani dan melaksanakan Perjanjian ini dan dokumen-dokumen lain sehubungan dengan Perjanjian ini, serta telah melaksanakan semua tindakan dan persyaratan yang disyaratkan untuk sahnya penandatanganan dan pelaksanaan Perjanjian ini dan dokumen-dokumen lain sehubungan dengan Perjanjian.",
      },
      {
        tag: "5.2",
        content:
          "Agen menyetujui dan memberikan izin kepada Perusahaan untuk mengumpulkan, menggunakan, mengelola, mengirimkan ataupun mengungkapkan sebagian ataupun keseluruhan informasi milik Agen (meliputi tetapi tidak terbatas kepada data pribadi Agen seperti Nama, Alamat, Nomor Identitas, Nomor Telepon, maupun berbagai bentuk informasi lainnya yang berkaitan dengan Agen), termasuk memberikannya kepada pihak ketiga yang berafiliasi dengan Perusahaan sepanjang dianggap perlu ataupun untuk memenuhi tujuan lainnya yang dapat meliputi tetapi tidak terbatas kepada kegiatan peragenan, pemasaran asuransi, penyediaan layanan kepada Nasabah, ataupun apabila dibutuhkan oleh peraturan perundang-undangan yang berlaku dan kebijakan Grup Prudential.",
      },
      {
        tag: "5.3",
        content:
          "Perjanjian ini dan dokumen-dokumen lain sehubungan dengan Perjanjian adalah sah, berlaku dan mengikat sah dan menimbulkan kewajiban hukum terhadap Agen, sesuai dengan syarat dan ketentuan yang tercantum di dalamnya.",
      },
      {
        tag: "5.4",
        content:
          "Setiap izin, pemberian kewenangan atau persetujuan yang diperlukan oleh Agen sehubungan dengan pelaksanaan, penyerahan, keabsahan, keberlakuan Perjanjian ini atau pelaksanaannya oleh Agen atas kewajibannya menurut Perjanjian ini telah diperoleh atau dibuat dan berlaku penuh.",
      },
    ],
  },
  {
    tag: "6.",
    content: "Evaluasi Agen",
    subContent:
      "Perusahaan berhak untuk melakukan evaluasi atas kinerja Agen (“Evaluasi”), sesuai dengan ketentuan validasi sebagaimana diatur dalam Lampiran II Perjanjian ini yang sewaktu-waktu dapat diubah mengikuti ketentuan yang ditetapkan oleh Perusahaan melalui Peraturan Keagenan. Berdasarkan hasil Evaluasi, atas kebijakan Perusahaan, Perusahaan dapat mempromosikan, melakukan demosi atau mengakhiri Perjanjian sesuai dengan Pasal 10.3.",
  },
  {
    tag: "7.",
    content: "Pemeriksaan Agen",
    subContent:
      "Perusahaan berhak setiap saat melakukan pemeriksaan atas seluruh kegiatan yang dilakukan oleh Agen dengan atau tanpa pemberitahuan terlebih dahulu. Selama pemeriksaan dan atas permintaan Perusahaan dan/atau orang yang ditunjuk oleh Perusahaan untuk melakukan pemeriksaaan, Agen wajib untuk menghadiri pertemuan secara fisik dan non fisik untuk memberikan keterangan serta memberikan seluruh dokumen dan informasi yang dimilikinya dengan benar dan secara terperinci kepada Perusahaan",
  },
  {
    tag: "8.",
    content: "Tindakan Disiplin dan Penangguhan",
    child: [
      {
        tag: "8.1",
        content:
          "Dalam hal Perusahaan menemukan bahwa Agen telah melakukan Pelanggaran (sebagaimana didefinisikan dalam Pasal 9.2), maka Perusahaan dapat, atas kebijakan Perusahaan, memberikan Tindakan Disiplin (sebagaimana didefinisikan dalam Pasal 8.2) kepada Agen, atau tindakan-tindakan lain yang dianggap perlu oleh Perusahaan.",
      },
      {
        tag: "8.2",
        content:
          "Tindakan disiplin yang dapat dikenakan kepada Agen oleh Perusahaan berdasarkan Perjanjian ini (tidak wajib dikenakan secara berurutan) adalah (i) peringatan tertulis, (ii) Penangguhan, (iii) pengakhiran Perjanjian Keagenan atau (iv) pencantuman nama Agen ke dalam Daftar Tenaga Pemasar Bermasalah AAJI (“Tindakan Disiplin”).",
      },
      {
        tag: "8.3",
        content: "Dalam hal Agen dikenakan Tindakan Disiplin Penangguhan:",
        child: [
          {
            tag: "8.3.1",
            content:
              "Perusahaan dapat menangguhkan sebagian atau seluruh hak Agen untuk mempromosikan, memasarkan dan menjual Produk Asuransi kepada Nasabah; dan/atau menerima Komisi dan <i>Overriding</i> (bila ada); dan/atau menerima kompensasi dan/atau pendapatan lain berdasarkan Perjanjian ini, Peraturan Keagenan, dan lampiran-lampirannya; dan/atau hak-hak lainnya (perjalanan insentif dan insentif lainnya) sesuai dengan keputusan dan batas waktu yang ditentukan oleh Perusahaan; dan",
          },
          {
            tag: "8.3.2",
            content:
              "Agen tetap wajib untuk mematuhi setiap dan seluruh syarat dan ketentuan dalam Perjanjian ini.",
          },
        ],
      },
      {
        tag: "8.4",
        content:
          "Dalam hal terdapat keluhan (<i>complaint</i>) terhadap Perusahaan yang diduga disebabkan oleh kelalaian atau kesalahan Agen dalam melakukan Jasa, Perusahaan dapat meminta Agen untuk membantu Perusahaan dalam melakukan investigasi dan Agen wajib untuk membantu investigasi serta memberikan seluruh informasi yang dimilikinya dengan benar kepada Perusahaan. Selama masa investigasi, Perusahaan dapat, atas kebijakan Perusahaan, mengenakan Tindakan Disiplin kepada Agen dan/atau menahan Komisi, insentif, kompensasi dan/atau pendapatan lain dalam bentuk apapun serta seluruh hak lainnya pada Perusahaan.",
      },
    ],
  },
  {
    tag: "9.",
    content: "Ganti Kerugian",
    child: [
      {
        tag: "9.1",
        content:
          "Perusahaan berhak untuk menyelesaikan setiap keluhan (<i>complaint</i>) dan/atau Kerugian Nasabah sesuai dengan syarat dan ketentuan yang dianggap baik menurut kebijakan Perusahaan tanpa kewajiban untuk memberitahu atau berkonsultasi terlebih dahulu dengan Agen.",
      },
      {
        tag: "9.2",
        content:
          "Agen wajib untuk mengganti segala Kerugian yang diderita oleh Perusahaan dan/atau Nasabah sebagai akibat dari salah satu dari hal-hal di bawah ini (“<b>Pelanggaran</b>”):",
        child: [
          {
            tag: "9.2.1",
            content:
              "Kelalaian atau kesalahan Agen dalam memenuhi kewajiban dan tanggung jawab Agen sebagaimana diuraikan dalam Pasal 3; atau",
          },
          {
            tag: "9.2.2",
            content:
              "Pelanggaran yang dilakukan oleh Agen atas setiap atau seluruh ketentuan dalam Perjanjian ini, lampiran-lampirannya, strategi, pedoman, perintah, Peraturan Keagenan dan/atau peraturan perundang-undangan yang berlaku, baik disengaja maupun tidak disengaja dan dengan cara apa pun; atau",
          },
          {
            tag: "9.2.3",
            content:
              "Pernyataan dan/atau Jaminan yang diberikan oleh Agen dalam Perjanjian ini ternyata atau terbukti tidak benar atau tidak sesuai dengan kenyataan sebenarnya.",
          },
        ],
      },
      {
        tag: "9.3",
        content:
          "Agen dengan ini membebaskan dan melepaskan Perusahaan, pemegang saham, para anggota direksi, komisaris dan karyawannya dari segala perlawanan, tuntutan, gugatan dalam bentuk apapun dan permintaan ganti rugi dari pihak ketiga yang timbul sehubungan dengan pelaksanaan Jasa dan setiap pelanggaran yang dilakukan oleh Agen atas syarat dan ketentuan yang diatur di dalam Perjanjian ini, maupun sehubungan dengan pemotongan sebagaimana diatur dalam Pasal 4.9.",
      },
    ],
  },
  {
    tag: "10.",
    content: "Jangka Waktu dan Pengakhiran Perjanjian",
    child: [
      {
        tag: "10.1",
        content:
          "Perjanjian ini mulai berlaku terhitung sejak tanggal Perusahaan membubuhkan tanda tangannya pada Perjanjian ini, sampai suatu waktu yang tidak terbatas, kecuali diakhiri oleh salah satu Pihak berdasarkan Pasal ini.",
      },
      {
        tag: "10.2",
        content:
          "Salah satu Pihak berhak untuk mengakhiri Perjanjian ini setiap saat, dengan memberikan pemberitahuan tertulis 14 (empat belas hari) sebelumnya kepada Pihak lainnya. Kecuali ditentukan lain dalam Pasal 10.4, tidak ada satu Pihak pun yang diiwajibkan untuk membayar kompensasi dalam bentuk apapun kepada Pihak lainnya ketika pengakhiran Perjanjian terjadi. Dalam hal Agen ingin mengakhiri Perjanjian ini, maka Agen wajib untuk memberikan surat pengakhiran Perjanjian yang memuat alasan pengakhiran Perjanjian, dan pengakhiran Perjanjian tersebut akan berlaku efektif pada tanggal yang pada surat konfirmasi pengakhiran dari Perusahaan.",
      },
      {
        tag: "10.3",
        content:
          "Perusahaan berhak untuk mengakhiri Perjanjian tanpa pemberitahuan sebelumnya kepada Agen, dalam hal salah satu dari hal-hal berikut terjadi:",
        child: [
          {
            tag: "10.3.1",
            content:
              "Agen meninggal dunia atau menderita Cacat Total dan Tetap sebagaimana didefinisikan pada Pasal 1.1.2; atau",
          },
          {
            tag: "10.3.2",
            content:
              "Agen dinyatakan dalam keadaan pailit atau diberikan penundaan kewajiban pembayaran hutang; atau",
          },
          {
            tag: "10.3.3",
            content:
              "Agen terlibat atau diduga terlibat dalam perkara hukum baik pidana maupun perdata; atau",
          },
          {
            tag: "10.3.4",
            content: "Agen melakukan Pelanggaran (sebagaimana didefinisikan dalam Pasal 9.2); atau",
          },
          {
            tag: "10.3.5",
            content: "Perjanjian diakhiri berdasarkan ketentuan-ketentuannya.",
          },
        ],
        content2:
          "Dengan tidak mengurangi ketentuan dalam Pasal ini, Pasal 10.3.3 tidak berlaku dalam hal menurut pendapat Perusahaan, jika Agen telah melaksanakan segala kewajibannya sesuai dengan Perjanjian ini, lampiran-lampirannya, strategi, pedoman, perintah, Peraturan Keagenan dan/atau peraturan perundang-undangan yang berlaku.",
      },
      {
        tag: "10.4",
        content: "Dengan berakhirnya Perjanjian:",
        child: [
          {
            tag: "10.4.1",
            content:
              "Agen wajib untuk, dalam jangka waktu selambat-lambatnya 7 (tujuh) hari kerja terhitung sejak tanggal efektif pengakhiran Perjanjian, mengembalikan setiap dan seluruh dokumen-dokumen dan barang-barang milik Perusahaan, baik dalam format elektronik maupun cetak.",
          },
          {
            tag: "10.4.2",
            content:
              "Para Pihak wajib menyelesaikan setiap dan segala kewajiban berdasarkan Perjanjian ini dan lampiran-lampirannya, serta perjanjian lain yang dibuat oleh dan antara Agen dan Perusahaan, dan Peraturan Keagenan, dalam jangka waktu selambat-lambatnya 7 (tujuh) hari kerja terhitung sejak tanggal pengakhiran Perjanjian.",
          },
          {
            tag: "10.4.3",
            content:
              "Agen tidak berhak untuk menuntut atau menerima Komisi, insentif, kompensasi atau pendapatan lain berdasarkan Perjanjian ini, lampiran-lampirannya, dan Peraturan Keagenan, terhitung setelah tanggal efektif pengakhiran Perjanjian ini (selain daripada jumlah yang telah jatuh tempo dan dapat dibayarkan kepada Agen sebelum tanggal efektif berakhirnya Perjanjian ini).",
          },
          {
            tag: "10.4.4",
            content:
              "Pasal 9, Pasal 10.5, Pasal 11.1, Pasal 12 dan Pasal 13 akan tetap berlaku dan mengikat Para Pihak.",
          },
        ],
      },
      {
        tag: "10.5",
        content:
          "Agen wajib untuk setiap saat, atas permintaan Perusahaan (walaupun Perjanjian telah berakhir), hadir di kantor Perusahaan dan/atau memberikan seluruh informasi yang dimilikinya dengan benar kepada Perusahaan, atau menghadiri setiap persidangan atau panggilan pihak yang berwajib dan regulator sebagai saksi, untuk memberikan bukti, informasi mengenai Nasabah, Jasa, atau Perjanjian ini.",
      },
      {
        tag: "10.6",
        content:
          "Dalam hal pengakhiran Perjanjian ini, Para Pihak mengesampingkan berlakunya Pasal 1266 Kitab Undang-Undang Hukum Perdata sepanjang diperlukannya putusan pengadilan bagi pengakhiran Perjanjian ini.",
      },
    ],
  },
  {
    tag: "11.",
    content: "Pembatasan",
    child: [
      {
        tag: "11.1",
        content:
          "Selama berlakunya Perjanjian ini dan untuk seterusnya setelah Perjanjian ini berakhir, Agen dilarang untuk secara langsung maupun tidak langsung dan dalam kapasitas apa pun:",
        child: [
          {
            tag: "11.1.1",
            content:
              "Membujuk atau dengan cara apa pun membuat Nasabah menebus (<i>surrender</i>) polis Perusahaan atau membiarkan polis Perusahaan tidak berlaku (<i>lapse</i>); dan",
          },
          {
            tag: "11.1.2",
            content:
              "Membujuk atau dengan cara apapun (i) membuat agen atau karyawan Perusahaan mengakhiri hubungan keagenan atau hubungan kerjanya dengan Perusahaan, atau (ii) mempekerjakan agen atau karyawan Perusahaan.",
          },
        ],
      },
    ],
  },
  {
    tag: "12.",
    content: "Kekayaan Intelektual",
    child: [
      {
        child: [
          {
            tag: "12.1",
            content:
              "Setiap Kekayaan Intelektual, termasuk Logo Perusahaan, hanya dapat digunakan oleh Agen semata-mata untuk melaksanakan Jasa sesuai dengan syarat dan ketentuan dalam Perjanjian ini. Para Pihak dengan ini setuju bahwa seluruh Kekayaan Intelektual, termasuk Logo Perusahaan, adalah milik Perusahaan dan/atau afiliasinya.",
          },
          {
            tag: "12.2",
            content:
              "Agen tidak diperkenankan untuk mengubah, mendaftarkan, memodifikasi dan/atau menggunakan Kekayaan Intelektual, termasuk Logo Perusahaan untuk maksud apa pun, tanpa persetujuan tertulis terlebih dahulu dari Perusahaan.",
          },
          {
            tag: "12.3",
            content:
              "Agen tidak diperkenankan untuk menggunakan, mengedarkan, mendistribusikan, menggandakan atau memperbanyak, baik secara langsung maupun tidak langsung, setiap kekayaan intelektual yang dimiliki oleh pihak ketiga manapun, termasuk namun tidak terbatas pada setiap hak paten, hak cipta, hak merek, rahasia dagang, hasil karya, desain, metode, teknik, proses, prosedur, ilustrasi, baik terdaftar maupun tidak, baik dalam bentuk cetak, audio atau video (selanjutnya disebut “<b>Penggunaan Kekayaan Intelektual</b>”), tanpa mendapatkan persetujuan tertulis terlebih dahulu dari pihak ketiga pemilik kekayaan intelektual tersebut.",
            subContent:
              "Agen akan bertanggung jawab sepenuhnya atas segala Penggunaan Kekayaan Intelektual tersebut dan akan membebaskan serta melepaskan Perusahaan, pemegang saham, para anggota direksi, komisaris dan karyawannya dari segala perlawanan, tuntutan, gugatan dalam bentuk apapun dan permintaan ganti rugi dari pihak ketiga yang timbul dari Penggunaan Kekayan Intelektual tersebut.",
          },
        ],
      },
    ],
  },
  {
    tag: "13.",
    content: "Kerahasiaan",
    child: [
      {
        tag: "13.1",
        content: "Agen wajib menjamin bahwa:",
        child: [
          {
            tag: "13.1.1",
            content: "semua Informasi Rahasia harus:",
            child: [
              {
                isTagNumber: true,
                tag: "a.",
                content: "digunakan semata-mata untuk maksud sebagaimana yang telah ditentukan;",
              },
              {
                isTagNumber: true,
                tag: "b.",
                content: "diperlakukan dengan tingkat kerahasiaan tinggi;",
              },
              {
                isTagNumber: true,
                tag: "c.",
                content:
                  "tidak digandakan kecuali bila memang benar-benar dibutuhkan untuk keperluan resmi; dan",
              },
              {
                isTagNumber: true,
                tag: "d.",
                content:
                  "dikembalikan dan/atau dihancurkan sesuai dengan petunjuk dari Perusahaan.",
              },
            ],
          },
          {
            tag: "13.1.2",
            content:
              "pengamanan dan pengawasan yang tepat dilakukan untuk melindungi dan menjaga semua Informasi Rahasia Perusahaan dari penggunaan dan/atau pengungkapan ke pihak ketiga yang tidak sah. Pengamanan dan pengawasan tersebut termasuk tetapi tidak terbatas pada: i) dalam hal Informasi Rahasia berbentuk dokumen, mengamankan tempat peralihan dan tempat penyimpanannya; dan ii) dalam hal Informasi Rahasia berbentuk media elektronik, menggunakan program anti-virus standar yang terkini yang digunakan dalam industri dan menggunakan piranti lunak pengarsipan atas semua peralatan komputer, laptop dan komputer jinjing.",
          },
        ],
      },
      {
        tag: "13.2",
        content:
          "Kewajiban untuk menjaga kerahasiaan sebagaimana dimaksud dalam Pasal 13 ini tidak berlaku terhadap informasi:",
        child: [
          {
            tag: "13.2.1",
            content:
              "yang ada, atau telah menjadi bagian dari ranah publik, bukan sebagai akibat dari pelanggaran atas kewajiban menjaga kerahasiaan berdasarkan Perjanjian ini; atau",
          },
          {
            tag: "13.2.2",
            content: "telah ada di dalam penguasaan Agen sebelum dimulainya Perjanjian ini; atau",
          },
          {
            tag: "13.2.3",
            content: "telah diungkapkan oleh pihak ketiga yang berhak untuk mengungkapkannya; atau",
          },
          {
            tag: "13.2.4",
            content:
              "diminta untuk diungkapkan oleh hukum yang berlaku, atau atas perintah pengadilan atau badan pemerintah atau lembaga yang memiliki yurisdiksi untuk itu.",
          },
        ],
      },
      {
        tag: "13.3",
        content:
          "Setiap adanya pelanggaran dari Pasal 13 ini dapat mengakibatkan diberikannya Tindakan Disiplin oleh Perusahaan.",
      },
      {
        tag: "13.4",
        content:
          "Pasal 13 ini akan tetap berlaku meski Perjanjian Keagenan ini telah berakhir atau kadaluarsa.",
      },
    ],
  },
  {
    tag: "14.",
    content: "Pemberitahuan",
    child: [
      {
        tag: "14.1",
        content:
          "Seluruh surat menyurat, pemberitahuan, atau komunikasi apapun berdasarkan Perjanjian ini dari satu Pihak kepada Pihak lainnya wajib untuk dibuat secara tertulis dan dikirimkan melalui pos tercatat atau melalui perusahaan ekspedisi (kurir) atau kurir internal atau surat elektronik (<i>e-mail</i> atau sarana komunikasi lainnya yang dapat ditentukan kemudian oleh Perusahaan) dengan alamat sebagaimana tertera dalam Perjanjian ini, atau perubahannya sebagaimana diberitahukan secara tertulis dari waktu ke waktu.",
      },
      {
        tag: "14.2",
        content:
          "Surat-menyurat atau pemberitahuan-pemberitahuan dan/atau komunikasi ke alamat tersebut di atas, dianggap telah diterima dengan ketentuan sebagai berikut:",
        child: [
          {
            tag: "14.2.1",
            content:
              "Pada hari yang sama, apabila diserahkan langsung yang dibuktikan dengan tanda tangan penerima pada buku pengantar surat (ekspedisi) atau tanda terima lain yang diterbitkan oleh Para Pihak.",
          },
          {
            tag: "14.2.2",
            content:
              "Pada hari kerja berikutnya setelah tanggal penerimaan, apabila dikirimkan melalui pos yang dibuktikan dengan resi penerimaan pos tercatat.",
          },
        ],
      },
      {
        tag: "14.3",
        content:
          "Dalam hal terjadi perubahan alamat Para Pihak, maka perubahan tersebut harus diberitahukan secara tertulis kepada Pihak lainnya dalam Perjanjian ini selambat-lambatnya 5 (lima) hari kerja sebelum perubahan alamat dimaksud berlaku efektif.",
      },
      {
        tag: "14.4",
        content:
          "Jika perubahan alamat tidak diberitahukan, maka surat-menyurat atau pemberitahuan-pemberitahuan sehubungan dengan Perjanjian ini dianggap telah diterima apabila dikirim dengan cara sebagaimana diatur dalam Pasal 14.1 dan Pasal 14.2 Perjanjian ini, dan ditujukan ke alamat di atas atau alamat sebagaimana diubah sesuai dengan Pasal 14.3 Perjanjian ini.",
      },
    ],
  },
  {
    tag: "15.",
    content: "Hukum Yang Berlaku",
    subContent:
      "Perjanjian ini diatur oleh dan harus ditafsirkan serta dilaksanakan berdasarkan hukum yang berlaku di Negara Republik Indonesia.",
  },
  {
    tag: "16.",
    content: "Penyelesaian Perselisihan",
    child: [
      {
        tag: "16.1",
        content:
          "Dalam hal terjadi perselisihan di antara Para Pihak mengenai pelaksanaan Perjanjian ini, maka Para Pihak sepakat untuk terlebih dahulu menyelesaikannya secara musyawarah.",
      },
      {
        tag: "16.2",
        content:
          "Jika melalui cara penyelesaian tersebut di atas tidak tercapai kesepakatan, maka Para Pihak sepakat untuk menyelesaikannya melalui Pengadilan Negeri dan untuk itu Para Pihak memilih domisili hukum yang tetap dan tidak berubah di Pengadilan Negeri Jakarta Selatan.",
      },
    ],
  },
  {
    tag: "17.",
    content: "Lain-Lain",
    child: [
      {
        tag: "17.1",
        content: "<b>Lampiran</b>",
        subContent:
          "Lampiran dari Perjanjian ini merupakan satu kesatuan dan bagian yang tidak dapat dipisahkan serta mempunyai kekuatan hukum yang sama serta mengikat seperti halnya pasal-pasal lain dari Perjanjian ini.",
      },
      {
        tag: "17.2",
        content: "<b>Kuasa</b>",
        subContent:
          "Semua kuasa dan wewenang yang diberikan oleh Agen dalam Perjanjian ini merupakan bagian terpenting dan tidak terpisahkan dari Perjanjian ini dan sebagai demikian maka kuasa dan wewenang tersebut tidak dapat ditarik/dicabut kembali dan juga tidak menjadi berakhir/hapus jika Agen meninggal dunia atau karena timbul peristiwa apa pun dan Para Pihak dengan ini melepaskan dan menyatakan tidak berlaku Pasal 1813, Pasal 1814 dan Pasal 1816 Kitab Undang-undang Hukum Perdata.",
      },
      {
        tag: "17.3",
        content: "<b>Pengalihan</b>",
        subContent:
          "Perjanjian ini berlaku dan mengikat terhadap Para Pihak maupun para penerima dan penerus hak dan kewajiban dalam Perjanjian ini, dengan ketentuan bahwa Para Pihak tidak dapat mengalihkan atau melepaskan hak dan/atau kewajibannya berdasarkan Perjanjian ini kepada pihak lain tanpa persetujuan tertulis terlebih dahulu dari Pihak lainnya.",
      },
      {
        tag: "17.4",
        content: "<b>Keabsahan Perjanjian</b>",
        subContent:
          "Apabila sebagian dari ketentuan-ketentuan dalam Perjanjian ini bertentangan dengan peraturan perundang-undangan yang berlaku atau tidak dapat dilaksanakan karena sebab apa pun, maka hal ini tidak mempengaruhi keabsahan dan pelaksanaan dari ketentuan-ketentuan lainnya dalam Perjanjian ini.",
      },
      {
        tag: "17.5",
        content: "<b>Agen Bukan Karyawan</b>",
        subContent:
          "Tidak ada satu pun dari ketentuan-ketentuan dalam Perjanjian ini yang dapat diartikan sebagai menciptakan hubungan ketenagakerjaan sebagaimana di atur dalam peraturan perundang-undangan yang berlaku antara Perusahaan dan Agen baik secara tegas maupun diam-diam.",
      },
      {
        tag: "17.6",
        content: "<b>Perubahan</b>",
        child: [
          {
            tag: "17.6.1",
            content:
              "Perusahaan dapat mengubah, menambah atau memodifikasi syarat dan ketentuan dalam Perjanjian, lampiran-lampirannya, Peraturan Keagenan dan/atau Ketentuan Komisi dengan pemberitahuan kepada Agen.",
          },
          {
            tag: "17.6.2",
            content:
              "Dengan tunduk pada Pasal 17.6.1, tidak ada perubahan, penambahan atau modifikasi pada Perjanjian, lampiran-lampirannya, Peraturan Keagenan dan/atau Ketentuan Komisi kecuali dibuat secara tertulis dan ditandatangani oleh pihak yang berwenang dari Perusahaan.",
          },
        ],
      },
      {
        tag: "17.7",
        content: "<b>Inkonsistensi</b>",
        subContent:
          "Dalam hal terdapat konflik atau inkonsistensi antara ketentuan dalam Perjanjian ini dan ketentuan-ketentuan dalam Peraturan Keagenan maka ketentuan yang berlaku adalah ketentuan yang paling akhir dikeluarkan oleh Perusahaan.",
      },
      {
        tag: "17.8",
        content: "<b>Pelepasan</b>",
        subContent:
          "Perusahaan tidak akan dianggap telah mengesampingkan suatu ketentuan dalam Perjanjian ini, kecuali pengesampingan tersebut adalah secara tertulis dan ditandatangani oleh Perusahaan. Kelalaian Perusahaan untuk menjalankan suatu hak menurut Perjanjian ini atau kelalaian Perusahaan untuk memaksa agar Agen dengan taat mematuhi syarat-syarat Perjanjian ini bukan merupakan suatu penolakan dari syarat-syarat Perjanjian ini dan bukan dianggap sebagai suatu pengesampingan oleh Perusahaan atas haknya untuk dikemudian hari meminta kepatuhan atas syarat-syarat Perjanjian ini.",
      },
      {
        tag: "17.9",
        content: "<b>Pajak</b>",
        child: [
          {
            tag: "17.9.1",
            content:
              "Para Pihak setuju bahwa pembayaran Komisi, <i>overriding</i>, dan tunjangan apa pun menurut Perjanjian ini masih berupa pembayaran kotor (<i>gross</i>), dalam artian didalam pembayaran tersebut termasuk Pajak Pertambahan Nilai (PPN) dan Pajak Penghasilan (PPh) serta kewajiban perpajakan lainnya sesuai dengan peraturan perpajakan yang berlaku yang menjadi tanggung jawab Agen.",
          },
          {
            tag: "17.9.2",
            content:
              "Agen yang sudah dikukuhkan sebagai <b>Pengusaha Kena Pajak (PKP)</b> oleh Kantor Pelayanan Pajak setempat, wajib menerbitkan Faktur Pajak selambatnya pada hari terakhir bulan berjalan, dan mengirimkannya kepada Perusahaan, selambat-lambatnya tanggal 10 bulan berikutnya.",
          },
        ],
      },
      {
        tag: "17.10",
        content: "<b>Akses Informasi</b>",
        subContent:
          "Perusahaan dapat, atas kebijakan Perusahaan, sewaktu-waktu membatasi atau menutup akses informasi Agen terhadap sistem informasi Perusahaan.",
      },
      {
        tag: "17.11",
        content: "<b>Anti Suap dan Korupsi</b>",
        subContent:
          "Dalam melaksanakan kewajiban-kewajiban berdasarkan Perjanjian Keagenan, Agen wajib:",
        child: [
          {
            tag: "17.11.1",
            content:
              "Tunduk pada seluruh peraturan dan perundang-undangan yang berlaku mengenai anti suap dan korupsi;",
          },
          {
            tag: "17.11.2",
            content:
              "Tidak menawarkan dan/atau menerima suap atau Pembayaran Fasilitasi apapun kepada pejabat publik atau pihak manapun lainnya; dan",
          },
          {
            tag: "17.11.3",
            content:
              "Tidak melakukan hal apapun yang dapat menyebabkan Perusahaan atau setiap afiliasinya melanggar peraturan perundang-undangan mengenai anti suap dan korupsi.",
          },
        ],
      },
    ],
    content2:
      'Untuk menghindari keraguan, yang dimaksud dengan Pembayaran Fasilitasi adalah pembayaran yang dilakukan sebagai upaya untuk mengamankan atau mempercepat proses kinerja rutin atau tindakan yang diperlukan, yang mana kita memiliki hak hukum atasnya. Pembayaran Fasilitasi bukanlah pembayaran untuk layanan yang tarifnya dipublikasikan secara umum dan tersedia untuk semua pihak, namun seperti proses "jalur cepat".',
    content3:
      "Agen wajib segera memberitahukan Perusahaan secara tertulis atas setiap potensi pelanggaran atau pelanggaran yang terjadi atas pasal ini. Apabila Agen melanggar atau terdeteksi melanggar pasal ini, Perusahaan dapat setiap saat mengakhiri Perjanjian Keagenan tanpa kewajiban apapun.",
  },
];

export const tcPkConventionalLampiranPage25To36 = [
  {
    tag: "1.",
    content: "Kewajiban Agen",
    child: [
      {
        tag: "1.1",
        content: "Kepatuhan Terhadap Peraturan Yang Berlaku",
        child: [
          {
            tag: "1.1.1",
            content:
              "Agen wajib mematuhi dan tunduk pada ketentuan peraturan yang berlaku, Kode Etik Agen, peraturan AAJI, OJK, Peraturan Anti Pencucian Uang dan Pencegahan Pendanaan Terorisme, Peraturan Anti Suap dan Korupsi dan peraturan lainnya yang dikeluarkan oleh Perusahaan termasuk segala perubahannya.",
          },
          {
            tag: "1.1.2",
            content:
              "Bertindak jujur dan etis, termasuk secara etis menangani benturan kepentingan yang terjadi atau nyata antara hubungan pribadi dengan hubungan profesional.",
          },
          {
            tag: "1.1.3",
            content:
              "Mendahulukan kepentingan Perusahaan yang sah, menghormati dan mengaplikasikan nilai-nilai dan standar Perusahaan.",
          },
          {
            tag: "1.1.4",
            content:
              "Mempromosikan dan meningkatkan citra Perusahaan dan bertindak sebagai penyedia jasa yang bertanggung jawab serta warga negara yang baik.",
          },
        ],
      },
    ],
  },
  {
    tag: "2",
    content: "Kepatuhan Terhadap Perjanjian Keagenan",
    subContent:
      "Agen wajib mematuhi dan tunduk pada ketentuan sebagaimana diatur dalam Perjanjian Keagenan, termasuk dalam melaksanakan seluruh hak dan kewajibannya.",
  },
  {
    tag: "3.",
    content: "Kewajiban Terhadap Profesi",
    child: [
      {
        tag: "3.1",
        content: "Perjanjian Keagenan",
        subContent:
          "Agen wajib memiliki dan menandatangani Perjanjian Keagenan hanya dengan satu Perusahaan Asuransi Jiwa dan dengan menggunakan kartu identitas diri yang sah dan berlaku, kecuali ditentukan lain oleh peraturan perasuransian yang berlaku. Perusahaan sewaktu-waktu dapat meminta dokumen tambahan untuk melakukan verifikasi terhadap identitas diri Agen.",
      },
      {
        tag: "3.2",
        content: "Sertifikasi Keagenan",
        subContent:
          "Agen wajib memiliki sertifikasi keagenan yang dikeluarkan oleh AAJI sebelum melakukan pemasaran dan/atau penjualan produk asuransi jiwa.",
      },
      {
        tag: "3.3",
        content: "Pelatihan dan Pengembangan",
        subContent:
          "Agen wajib mengikuti pelatihan dan pengembangan dasar dan lanjutan untuk meningkatkan profesionalisme pekerjaannya sebagaimana disyaratkan oleh peraturan perundang-undangan, peraturan AAJI, OJK dan Perusahaan.",
      },
    ],
  },
  {
    tag: "4.",
    content: "Kewajiban Terhadap Perusahaan",
    child: [
      {
        tag: "4.1",
        content:
          "Dalam prinsip hubungan antara Agen dengan Perusahaan, Agen harus menunjukkan kejujuran, niat baik dan kesetiaan dalam semua kegiatan keagenan.",
      },
      {
        tag: "4.2",
        content:
          "Agen harus secara tegas memahami dan patuh terhadap semua prosedur dan kebijakan Perusahaan yang berlaku.",
      },
      {
        tag: "4.3",
        content:
          "Agen wajib menggunakan dokumen pemasaran resmi dan terkini yang dikeluarkan oleh Perusahaan yang diwakilinya.",
      },
      {
        tag: "4.4",
        content:
          "Agen wajib melakukan kegiatan pemasaran sesuai dengan ketentuan yang berlaku di Perusahaan Asuransi Jiwa yang diwakilinya.",
      },
      {
        tag: "4.5",
        content: "Premi",
        child: [
          {
            tag: "4.5.1",
            content:
              "Agen wajib memberitahukan jumlah premi yang telah dibayarkan oleh calon Nasabah atau Nasabah sesuai dengan yang ditetapkan oleh Perusahaan.",
          },
          {
            tag: "4.5.2",
            content:
              "Agen harus bertindak sebagai pihak yang dipercaya atas beberapa tanggung jawab dan penjagaan informasi rahasia.",
          },
          {
            tag: "4.5.3",
            content:
              "Agen tidak dibolehkan menggunakan setiap dan seluruh aset Perusahaan termasuk laporan, materi pelatihan, brosur, literatur dan/atau materi lain selain untuk tujuan yang bermanfaat bagi Perusahaan.",
          },
        ],
      },
      {
        tag: "4.6",
        content: "Hak Milik Intelektual",
        child: [
          {
            tag: "4.6.1",
            content:
              "Agen wajib mendapatkan persetujuan dari Perusahaan yang diwakilinya dalam hal Agen bermaksud menggunakan karya cipta, paten, merek dan/atau logo, termasuk namun tidak terbatas pada piranti lunak komputer (<i>software</i>) dari Perusahaan.",
          },
          {
            tag: "4.6.2",
            content:
              "Agen tidak diizinkan untuk menggunakan logo atau merek Prudential (dengan logo atau merk lain atau untuk tujuan bisnis lainnya) selain dari penggunaan yang telah disetujui oleh Perusahaan dan Agen tidak diizinkan untuk mengubah/menambah hak atas Kekayaan Intelektual Perusahaan dengan berbagai cara apapun yang dapat membawa risiko atau merusak reputasi baik Perusahaan.",
          },
        ],
      },
      {
        tag: "4.7",
        content: "Kepemilikan dan Kerahasiaan Atas Data Nasabah",
        subContent:
          "Setiap data Nasabah adalah milik dari Perusahaan. Agen dilarang untuk memberitahukan kepada pihak ketiga dan/atau menggunakan data Nasabah dan informasi lainnya yang didapatkan dalam rangka menjalankan kewajibannya sebagai Agen termasuk informasi mengenai Perusahaan kepada pihak ketiga selain untuk kepentingan Perusahaan, kecuali:",
        child: [
          {
            tag: "4.7.1",
            content:
              "setelah mendapat persetujuan dari Perusahaan dalam hal informasi yang berkaitan dengan Perusahaan, atau dari Perusahaan, AAJI, OJK dan Nasabah dalam hal berkaitan dengan data Nasabah, atau",
          },
          {
            tag: "4.7.2",
            content:
              "untuk melaksanakan perintah dari pejabat pemerintah, AAJI, OJK dan pengadilan berdasarkan peraturan yang berlaku.",
          },
        ],
      },
      {
        tag: "4.8",
        content: "SPAJ dan Kelengkapannya",
        subContent:
          "Agen wajib selalu memastikan bahwa Nasabah memberikan informasi yang jelas, benar dan lengkap dalam pengisian SPAJ maupun semua dokumen kelengkapan lainnya. Agen dilarang memanipulasi dan merubah data-data yang diberikan oleh Nasabah (kecuali dengan persetujuan tertulis terlebih dahulu dari Nasabah dan Perusahaan dalam hal polis telah diterbitkan).",
      },
      {
        tag: "4.9",
        content: "Laporan Agen",
        subContent:
          "Dalam setiap permohonan asuransi jiwa dari calon Nasabah, Agen wajib senantiasa memberikan informasi yang jelas, benar dan lengkap tentang Nasabah dalam laporan Agen sebagaimana ditetapkan oleh Perusahaan.",
      },
      {
        tag: "4.10",
        content: "Tindak Pidana Pencucian Uang <i>(Anti Money Laundering)</i>",
        subContent:
          "Agen wajib senantiasa mematuhi segala aturan dan ketentuan tentang tindak pidana pencucian uang yang ditetapkan oleh Perusahaan dan peraturan perundang-undangan serta wajib mengikuti pelatihan-pelatihan mengenai anti pencucian uang yang diselenggarakan oleh Perusahaan sebagaimana ditetapkan oleh perundang-undangan dan aturan pemerintah yang berlaku.",
      },
      {
        tag: "4.11",
        content: "<i>Pooling</i>",
        subContent:
          "Agen dilarang untuk mengalihkan penjualan produk yang telah dilakukannya kepada Agen lainnya. Agen yang tercatat dalam dokumen SPAJ merupakan Agen yang melakukan prospek, presentasi dan penjualan kepada calon Nasabah atau Nasabah hingga pada saat calon Nasabah atau Nasabah melakukan penandatanganan SPAJ tersebut. Agen wajib menolak namanya dicantumkan dalam dokumen SPAJ apabila dirinya tidak melakukan prospek atau penjualan produk asuransi jiwa kepada calon Nasabah atau Nasabah.",
      },
      {
        tag: "4.12",
        content: "Rekrutmen Agen",
        subContent:
          "Dengan tetap mengindahkan peraturan dan perundang-undangan yang berlaku, setiap Agen yang melakukan perekrutan Agen bagi Perusahaan wajib memastikan bahwa Agen yang akan direkrut menyerahkan:",
        child: [
          {
            tag: "4.12.1",
            content:
              "Salinan surat pengunduran diri Agen dari Perusahaan Asuransi Jiwa terdahulu (apabila pengakhiran Perjanjian Keagenan terjadi karena Agen mengundurkan diri) dan Salinan surat persetujuan Perusahaan Asuransi Jiwa atas pengunduran diri Agen tersebut. Salinan surat persetujuan Perusahaan Asuransi Jiwa atas pengunduran diri Agen tidak diperlukan apabila Perusahaan Asuransi Jiwa terdahulu tidak mengeluarkan surat persetujuan dalam jangka waktu 30 (tiga puluh) hari sejak surat pengunduran diri tersebut diterima oleh Perusahaan Asuransi Jiwa terdahulu; atau salinan surat pengakhiran Perjanjian Keagenan (apabila pengakhiran Perjanjian Keagenan terjadi karena pemutusan perjanjian oleh Perusahaan Asuransi Jiwa terdahulu).",
          },
          {
            tag: "4.12.2",
            content:
              "Salinan surat pernyataan Agen yang berpindah dari suatu Perusahaan Asuransi Jiwa ke Perusahaan Asuransi Jiwa Iainnya untuk tidak melakukan <i>Twisting</i>. Definisi <i>Twisting</i> dijelaskan pada pasal 5.1 dalam lampiran III ini.",
          },
        ],
      },
      {
        tag: "4.13",
        content: "Perpindahan Agen",
        subContent:
          "Apabila Agen bermaksud untuk pindah dari suatu Perusahaan Asuransi Jiwa ke Perusahaan Asuransi Jiwa lainnya, maka Agen wajib melakukan perpindahan sesuai dengan ketentuan dalam peraturan dan perundang-undangan yang berlaku dan wajib menyerahkan kepada Perusahaan Asuransi Jiwa terdahulu:",
        child: [
          {
            tag: "4.13.1",
            content: "Asli surat pengunduran diri.",
          },
          {
            tag: "4.13.2",
            content:
              "Asli surat pernyataan Agen yang berpindah untuk tidak melakukan <i>Twisting</i>. Dan selanjutnya wajib menyerahkan kepada Perusahaan Asuransi Jiwa yang baru:",
            child: [
              {
                isTagNumber: true,
                tag: "a.",
                content:
                  "Salinan surat pengunduran diri (apabila pengakhiran Perjanjian Keagenan terjadi karena Agen mengundurkan diri) dan Salinan surat persetujuan Perusahaan Asuransi Jiwa atas pengunduran diri Agen tersebut. Salinan surat persetujuan Perusahaan atas pengunduran diri Agen tidak diperlukan apabila Perusahaan Asuransi Jiwa terdahulu tidak mengeluarkan surat persetujuan dalam jangka waktu 30 (tiga puluh) hari sejak surat pengunduran diri tersebut diterima oleh Perusahaan Asuransi Jiwa terdahulu; atau salinan surat pengakhiran Perjanjian Keagenan (apabila pengakhiran Perjanjian Keagenan terjadi karena pemutusan perjanjian oleh Perusahaan Asuransi Jiwa terdahulu).",
              },
              {
                isTagNumber: true,
                tag: "b.",
                content:
                  "Salinan surat pernyataan Agen yang akan berpindah untuk tidak melakukan <i>Twisting.</i>",
              },
            ],
          },
        ],
      },
      {
        tag: "4.14",
        content: "Keterbukaan",
        subContent:
          "Agen wajib setiap saat memberikan informasi yang jelas, benar, dan lengkap kepada Perusahaan, calon Nasabah dan Nasabah. Agen dilarang menyampaikan informasi yang bersifat keliru dan menyesatkan kepada Perusahaan, calon Nasabah dan Nasabah.",
      },
      {
        tag: "4.15",
        content: "Bantuan Investigasi, Pemeriksaan dan Audit",
        subContent:
          "Agen wajib senantiasa memberikan bantuan yang wajar kepada Perusahaan dalam hal terjadi investigasi atau pemeriksaan terkait usaha perasuransian, baik dari tim pemeriksa Perusahaan sendiri, pihak ketiga maupun dari pihak yang berwenang dari pemerintah. Bantuan tersebut termasuk tapi tidak terbatas pada memberikan kesempatan, akses terhadap data-data terkait yang ada pada Agen.",
      },
      {
        tag: "4.16",
        content: "Presentasi Penjualan",
        subContent:
          "Agen dalam melakukan pemasaran dan/atau penjualan wajib memastikan, termasuk tapi tidak terbatas atas hal-hal sebagai berikut:",
        child: [
          {
            tag: "4.16.1",
            content:
              "Agen wajib menerangkan dan memberikan penjelasan mengenai ringkasan informasi produk kepada calon Nasabah atau Nasabah.",
          },
          {
            tag: "4.16.2",
            content:
              "Calon Nasabah atau Nasabah telah memahami produk asuransi yang hendak dibeli termasuk namun tidak terbatas pada ketentuan mengenai resiko, premi dan manfaat asuransi.",
          },
          {
            tag: "4.16.3",
            content:
              "Agen wajib meminta calon Nasabah atau Nasabah untuk mengisi formulir SPAJ sendiri, jika calon Nasabah atau Nasabah tidak dapat melakukannya, Agen wajib menjelaskan formulir SPAJ tersebut kepada calon Nasabah atau Nasabah dan membacakan pertanyaan-pertanyaan yang harus dijawab calon Nasabah atau Nasabah sehingga calon Nasabah atau Nasabah mengerti dan bisa mendiktekan jawabannya.",
          },
          {
            tag: "4.16.4",
            content:
              "Calon Nasabah atau Nasabah telah memahami bahwa calon Nasabah atau Nasabah wajib mengungkapkan dengan jujur segala informasi yang berkaitan dengan riwayat kesehatan, usia, pekerjaan dan hal-hal lain yang dapat mempengaruhi keputusan Perusahaan dalam hal penjualan produk asuransi atau besarnya premi kepada calon Nasabah atau Nasabah.",
          },
        ],
      },
      {
        tag: "4.17",
        content: "Manipulasi Penjualan",
        subContent:
          "Agen dilarang untuk memanipulasi penjualan untuk tujuan mendapatkan insentif atau memenangkan kontes atau <i>award</i>. Termasuk contoh dalam kegiatan memanipulasi penjualan adalah melakukan bujukan untuk mengakhiri polis segera setelah mendapatkan insentif atau memenangkan kontes atau <i>award.</i>",
      },
      {
        tag: "4.18",
        content: "Pencemaran Nama Baik",
        subContent:
          "Agen dilarang mencemarkan nama baik dan reputasi Perusahaan dan lembaga asuransi lainnya.",
      },
      {
        tag: "4.19",
        content: "Pelaporan Pelanggaran",
        subContent:
          "Agen wajib melaporkan kepada Perusahaan jika ia mengetahui adanya Agen lain atau Tenaga Pemasar Non Agen lain yang melakukan pelanggaran atas Kode Etik Agen ini dan atau peraturan perasuransian yang berlaku.",
      },
      {
        tag: "4.20",
        content:
          "Persekongkolan Agen untuk menghilangkan, menghapus atau mengubah informasi mengenai (calon) Nasabah akan dianggap sebagai tindakan tidak beretika dan penipuan.",
      },
      {
        tag: "4.21",
        content:
          "Agen harus mengetahui dan mengerti Produk Asuransi Perusahaan yang mereka pasarkan.",
      },
      {
        tag: "4.22",
        content:
          "Agen tidak diperkenankan untuk merekrut dan merekomendasikan agen-agen atau nasabah-nasabah yang diketahui memiliki moral dan standar etika yang buruk.",
      },
      {
        tag: "4.23",
        content:
          "Agen bertanggung jawab untuk bertindak selaku <i>field underwriter</i> untuk Perusahaan, bertemu secara langsung dengan (calon) Nasabah dan (calon) Tertanggung untuk mengumpulkan informasi yang lengkap dan tepat sehubungan dengan (calon) Nasabah dan (calon) Tertanggung mengenai risiko yang dapat timbul untuk disampaikan secara lengkap kepada Perusahaan.",
      },
      {
        tag: "4.24",
        content: "Keterlibatan dalam aktivitas pencucian uang",
        subContent:
          "Membantu Nasabah memanfaatkan polis asuransi untuk mengubah identitas dana yang diperoleh dari aktivitas ilegal supaya tampak berasal dari sumber yang sah.",
      },
    ],
  },
  {
    tag: "5.",
    content: "Kewajiban Agen Kepada Nasabah",
    child: [
      {
        tag: "5.1",
        content:
          "Agen dilarang untuk melakukan tindakan Pemutarbalikan (<i>Twisting</i>) dan Pencampuradukan <i>(Churning)</i>.",
        subContent:
          "<i>Twisting</i> adalah tindakan Tenaga Pemasar yang membujuk dan/atau mempengaruhi pemegang polis untuk merubah spesifikasi polis yang ada atau mengganti polis yang ada dengan polis yang baru pada Perusahaan Asuransi Jiwa lainnya dan/atau membeli polis baru dengan menggunakan dana yang berasal dari polis yang masih aktif pada suatu Perusahaan Asuransi Jiwa lainnya dalam waktu 6 (enam) bulan sebelum dan sesudah tanggal polis baru di Perusahaan Asuransi Jiwa lain diterbitkan.",
        subContent2:
          "<i>Twisting Internal</i> atau <i>Churning</i> adalah tindakan membujuk dan mempengaruhi pemegang polis untuk merubah spesifikasi polis yang ada atau mengganti polis yang ada dengan polis yang baru pada Perusahaan Asuransi Jiwa yang sama, dan/atau membeli polis baru dengan menggunakan dana yang berasal dari polis yang masih aktif dari Perusahaan Asuransi Jiwa yang sama tanpa penjelasan terlebih dahulu kepada pemegang polis mengenai kerugian yang dapat diderita oleh pemegang polis akibat perubahan penggantian tersebut. <i>Twisting Internal</i> atau <i>Churning</i> mengacu pada peraturan Perusahaan yang diterbitkan dari waktu ke waktu.",
      },
      {
        tag: "5.2",
        content: "Pengisian Formulir",
        subContent: "Agen dilarang untuk:",
        child: [
          {
            tag: "5.2.1",
            content:
              "Meminta atau membiarkan calon Nasabah dan/atau Nasabah untuk menandatangani SPAJ kosong atau formulir asuransi kosong lainnya.",
          },
          {
            tag: "5.2.2",
            content:
              "Menandatangani atau membubuhkan paraf atau tanda tangan calon Nasabah dan/atau Nasabah, walaupun calon Nasabah dan/atau Nasabah tersebut menyetujuinya.",
          },
          {
            tag: "5.2.3",
            content:
              "Agen dilarang membuat laporan apabila Agen tidak bertemu/berhadapan langsung dengan (calon) Nasabah dan/atau (calon) Tertanggung dan menyaksikan sendiri (calon) Nasabah dan/atau (calon) Tertanggung mengisi dan menandatangani SPAJ dan formulir asuransi lainnya.",
          },
        ],
      },
      {
        tag: "5.3",
        content: "Penyalahgunaan Dana Nasabah <i>(Misappropriation of Funds)</i>",
        subContent:
          "Agen dilarang untuk mengambil atau menyalahgunakan pembayaran premi, uang atau harta benda lain milik Perusahaan yang diterima dari calon Nasabah dan/atau Nasabah. Penundaan penyetoran premi yang diterima dari Nasabah atau calon Nasabah kepada Perusahaan setelah melewati jangka waktu 48 (empat puluh delapan) jam terhitung sejak Agen menerima premi termasuk juga dalam kategori penyalahgunaan dana.",
      },
      {
        tag: "5.4",
        content: "Penyerahan Dokumen Kepada Nasabah",
        subContent:
          "Perusahaan dapat sewaktu-waktu mempercayakan dokumen-dokumen Nasabah seperti polis atau dokumen lainnya kepada Agen untuk diserahkan dengan segera kepada Nasabah. Agen wajib menyerahkan polis atau dokumen dari Perusahaan kepada Nasabah serta mendapatkan tanda terima.",
        subContent2:
          "Selanjutnya Agen wajib menyerahkan tanda terima dokumen tersebut kepada Perusahaan. Agen wajib segera memberitahukan kepada Perusahaan apabila ia gagal mengirimkan dokumen-dokumen tersebut kepada Nasabah beserta alasannya dan segera mengembalikan dokumen-dokumen tersebut kepada Perusahaan.",
      },
      {
        tag: "5.5",
        content: "Pendanaan dan Pembayaran Atas Premi",
        subContent:
          "Agen dilarang untuk melakukan pendanaan kewajiban pembayaran premi Nasabah terhadap Perusahaan dengan dananya sendiri, baik hal yang merupakan pembayaran dimuka (premi pertama) atau pembayaran premi lanjutan kecuali Agen tersebut memiliki hubungan suami istri atau keluarga sedarah dalam satu garis ke atas dan ke bawah dengan Nasabah.",
      },
      {
        tag: "5.6",
        content: "Diskon, <i>Rebate</i> dan <i>Inducement</i>",
        child: [
          {
            tag: "5.6.1",
            content:
              "Kecuali ditentukan lain dalam Peraturan Keagenan, Agen dilarang baik secara langsung maupun tidak langsung menawarkan dan/atau menjanjikan dan/atau memberikan potongan/diskon bagi calon Nasabah atau Nasabah sehubungan dengan pembayaran premi sehingga jumlah premi yang dibayar untuk suatu polis lebih rendah dari jumlah premi yang tertera dalam polis atau menawarkan potongan komisi kepada Nasabah atau calon Nasabah sebagai alat untuk membujuk/mendorong agar calon Nasabah atau Nasabah membeli polis dari Agen.",
          },
          {
            tag: "5.6.2",
            content:
              "Agen dilarang baik secara langsung maupun tidak langsung menjanjikan untuk memberikan dan/atau memberikan benda lain yang berharga yang dimaksudkan untuk memberikan potongan premi kepada calon Nasabah atau Nasabah.",
          },
          {
            tag: "5.6.3",
            content:
              "Agen dilarang baik secara langsung maupun tidak langsung meminta atau menerima hadiah, manfaat atau pemberian dari Nasabah sebagai balasan untuk setiap jasa yang dilakukan Agen.",
          },
        ],
      },
      {
        tag: "5.7",
        content: "Penerima Manfaat",
        subContent:
          "Agen dilarang menjadi penerima manfaat dari tertanggung, kecuali terdapat hubungan <i>insurable interest</i> antara tertanggung dan Agen tersebut.",
      },
      {
        tag: "5.8",
        content: "Pemasaran dan Presentasi",
        subContent:
          "Agen melakukan penjualan produk asuransi berdasarkan kebutuhan calon Nasabah atau Nasabah. Dengan demikian Agen wajib:",
        child: [
          {
            tag: "5.8.1",
            content:
              "Memperlihatkan sertifikasi keagenannya kepada calon Nasabah atau Nasabah sebelum memulai proses pemasaran dan penjualan.",
          },
          {
            tag: "5.8.2",
            content: "Mengenali kebutuhan calon Nasabah atau Nasabah.",
          },
          {
            tag: "5.8.3",
            content:
              "Pada saat wawancara pertama dengan calon Nasabah atau Nasabah, Agen wajib meluangkan cukup waktu untuk membicarakan konsep asuransi, rencana keuangan dan melakukan analisa kebutuhan calon Nasabah atau Nasabah akan produk asuransi.",
          },
          {
            tag: "5.8.4",
            content:
              'Mengaplikasikan prinsip/aturan "KENALI NASABAH ANDA" sebagaimana diatur dalam peraturan yang berlaku.',
          },
          {
            tag: "5.8.5",
            content:
              "Mengajukan pertanyaan yang tepat untuk menentukan jika satu produk cocok untuk calon Nasabah atau Nasabah. Agen wajib mendengarkan tujuan dan kebutuhan calon Nasabah atau Nasabah yang diungkapkan untuk dapat menilai produk asuransi yang cocok untuk calon Nasabah atau Nasabah.",
          },
          {
            tag: "5.8.6",
            content:
              "Menilai secara tepat apakah satu produk asuransi yang disarankan cocok untuk calon Nasabah atau Nasabah, informasi atas pertanyaan berikut dapat dijadikan acuan, antara lain:",
            child: [
              {
                isTagNumber: true,
                tag: "a.",
                content: "Apa pekerjaan, usaha dan posisi dari calon Nasabah atau Nasabah?",
              },
              {
                isTagNumber: true,
                tag: "b.",
                content: "Berapa usia calon Nasabah atau Nasabah?",
              },
              {
                isTagNumber: true,
                tag: "c.",
                content:
                  "Dimana dia tinggal? Apakah lingkungan tempat tinggalnya di kalangan atas?",
              },
              {
                isTagNumber: true,
                tag: "d.",
                content:
                  "Apakah menikah, siapa suami/istri dari calon Nasabah atau Nasabah dan bagaimana status pernikahannya?",
              },
              {
                isTagNumber: true,
                tag: "e.",
                content: "Apa hobi calon Nasabah atau Nasabah? Apakah hobi tersebut umum?",
              },
              {
                isTagNumber: true,
                tag: "f.",
                content: "Berapa penghasilan calon Nasabah atau Nasabah?",
              },
              {
                isTagNumber: true,
                tag: "g.",
                content: "Siapa saja dan berapa banyak jumlah tanggungannya?",
              },
            ],
          },
          {
            tag: "5.8.7",
            content:
              "Menjelaskan secara lengkap mengenai produk asuransi yang akan dipasarkan termasuk mengenai:",
            child: [
              {
                isTagNumber: true,
                tag: "a.",
                content: "Fitur produk asuransi.",
              },
              {
                isTagNumber: true,
                tag: "b.",
                content: "Manfaat produk asuransi.",
              },
              {
                isTagNumber: true,
                tag: "c.",
                content: "Persyaratan-persyaratan yang berkaitan dengan produk asuransi.",
              },
              {
                isTagNumber: true,
                tag: "d.",
                content:
                  "Memelihara tingkat profesionalisme dengan selalu mendapatkan informasi terbaru mengenai produk Perusahaan, kebijakan dan ketentuan Perusahaan.",
              },
              {
                isTagNumber: true,
                tag: "e.",
                content:
                  "Memastikan bahwa setiap pertanyaan yang terdapat dalam SPAJ telah dipahami oleh Calon Nasabah atau Nasabah.",
              },
              {
                isTagNumber: true,
                tag: "f.",
                content:
                  "Dalam hal Nasabah memilih pengiriman polis melalui Agen, maka Agen sangat disarankan untuk mengantar sendiri polis kepada Nasabah segera untuk menjelaskan kembali spesifikasi Produk Asuransi yang dibeli dan menegaskan keinginan Nasabah membeli Produk Asuransi tersebut. Agen harus meminta bukti penerimaan polis dari Nasabah.",
              },
            ],
          },
        ],
      },
      {
        tag: "5.9",
        content: "Benturan Kepentingan",
        subContent:
          "Agen tidak boleh merugikan kepentingan calon Nasabah atau Nasabah atau Perusahaan untuk suatu tujuan guna mendapatkan keuntungan pribadi. Agen wajib memberitahukan kepada calon Nasabah atau Nasabah mengenai hal-hal yang dimiliki oleh Agen yang memiliki potensi benturan kepentingan terhadap kepentingan kebutuhan calon Nasabah atau Nasabah dan/atau dapat mempengaruhi obyektivitas dan independensi Agen dalam memberikan nasihat keuangan kepada calon Nasabah atau Nasabah. Agen juga tidak dapat memberikan nasihat keuangan di luar kapasitas dan pengetahuannya selaku pemasar produk asuransi jiwa Perusahaan.",
      },
      {
        tag: "5.10",
        content: "Misrepresentasi",
        child: [
          {
            tag: "5.10.1",
            content: "Ilustrasi",
            subContent:
              "Agen wajib menyediakan/menyampaikan informasi mengenai produk secara benar, tepat, lengkap dan dalam Bahasa yang sederhana dengan mengacu pada ketentuan dari Perusahaan melalui materi atau alat yang telah disediakan oleh Perusahaan. Agen dilarang membuat perubahan terhadap ilustrasi yang disediakan Perusahaan tanpa seijin dari Perusahaan.",
          },
          {
            tag: "5.10.2",
            content: "Pernyataan yang menyesatkan",
            subContent:
              "Agen dilarang membuat pernyataan yang menyesatkan dalam proses kegiatan penjualan atau pemasaran mereka. Informasi yang penting sebagai dasar pengambilan keputusan harus secara penuh dan akurat diungkapkan sebelum dan pada saat penjualan dilakukan.",
          },
          {
            tag: "5.10.3",
            content: "Perbandingan yang tidak lengkap",
            subContent:
              "Agen dilarang memberikan perbandingan yang tidak lengkap atau tidak benar dari setiap polis dari suatu Perusahaan dengan yang lainnya dengan niat untuk meyakinkan Nasabah dalam membeli produk asuransi, atau untuk mengakhiri atau menebus polis.",
          },
        ],
      },
      {
        tag: "5.11",
        content: "Pelayanan",
        subContent:
          "Agen wajib memberikan pelayanan secara profesional, menyeluruh, efisien, konsisten dan berkelanjutan kepada Nasabah dan Perusahaan. Untuk itu, Agen wajib memiliki pengetahuan yang memadai tentang produk asuransi Perusahaan dan prinsip-prinsip asuransi.",
      },
      {
        tag: "5.12",
        content: "Pemalsuan",
        subContent:
          "Agen dilarang memalsukan dokumen baik secara langsung maupun tidak langsung. Memalsukan tanda tangan Nasabah baik secara langsung atau tidak langsung terhadap setiap dokumen yang berkaitan dengan bisnis Perusahaan. Tuduhan atau kecurigaan atas pelanggaran diatas akan diinvestigasi oleh Perusahaan untuk selanjutnya diambil tindakan yang tegas.",
      },
      {
        tag: "5.13",
        content: "Agen yang tidak berwenang",
        subContent:
          "Agen dilarang baik secara langsung maupun tidak langsung menunjuk, meminta, menginstruksikan, memberikan kuasa kepada seseorang yang dikenal yang tidak berwenang atau tidak mempunyai lisensi untuk memasarkan polis atas nama Agen.",
      },
    ],
  },
  {
    tag: "6.",
    content: "Hubungan dengan Rekan Seprofesi",
    child: [
      {
        tag: "6.1",
        content:
          "Hubungan dengan sesama Agen atau rekan seprofesi Perusahaan harus dilandasi sikap saling menghargai dan mempercayai. Sangat dianjurkan untuk membina hubungan baik dengan kantor keagenan lain, menciptakan persaingan usaha yang sehat dan memotivasi sesama Agen untuk menerapkan standar yang sama.",
      },
      {
        tag: "6.2",
        content:
          "Agen tidak dibolehkan untuk mengambil atau membujuk Nasabah dan/atau calon Nasabah Agen lain untuk mengganti Agen.",
      },
      {
        tag: "6.3",
        content:
          "Keberatan-keberatan terhadap tindakan sesama Agen atau rekan dalam Perusahaan yang dianggap bertentangan dengan Kode Etik ini harus diajukan kepada pegawai yang ditunjuk Perusahaan untuk bertanggung jawab atas Agen dan tidak dibenarkan untuk disampaikan kepada pihak luar Perusahaan termasuk penyiaran melalui media massa, sosial media atau media komunikasi lainnya diluar Perusahaan.",
      },
      {
        tag: "6.4",
        content:
          "Agen dilarang membujuk Agen lain untuk pindah ke unit atau kantor keagenan lain. Dalam hal perpindahan tersebut merupakan tindakan yang harus dilakukan dalam melaksanakan Kode Etik ini, maka Agen yang baru harus mendiskusikan situasi tersebut dengan manajer keagenan atau kantor keagenan yang berkaitan dan wakil yang ditunjuk Perusahaan.",
      },
    ],
  },
  {
    tag: "7.",
    content: "Sanksi Pelanggaran Kode Etik",
    child: [
      {
        tag: "7.1",
        content:
          "Setiap tindakan yang dianggap sebagai pelanggaran terhadap Kode Etik ini akan diinvestigasi oleh Perusahaan. Setelah selesainya proses investigasi, Perusahaan akan memutuskan tindakan disiplin yang tepat terhadap Agen yang melanggar Kode Etik ini antara lain, berupa:",
        child: [
          {
            tag: "7.1.1",
            content: "Peringatan tertulis;",
          },
          {
            tag: "7.1.2",
            content:
              "Pelaporan pelanggaran Agen kepada AAJI untuk dimasukkan ke dalam Daftar Tenaga Pemasar Bermasalah dan/atau untuk dilakukan pencabutan sertifikasi keagenan;",
          },
          {
            tag: "7.1.3",
            content: "Penonaktifan Agen sementara (skorsing); dan/atau",
          },
          {
            tag: "7.1.4",
            content:
              "Pengakhiran Perjanjian Keagenan, Pengenaan sanksi dapat dilakukan secara sekaligus bergantung kepada jenis pelanggaran ketentuan Kode Etik Agen.",
          },
        ],
      },
      {
        tag: "7.2",
        content:
          "AAJI dapat mengenakan sanksi kepada setiap Agen yang melakukan pelanggaran Kode Etik Agen berdasarkan pelaporan tertulis dari Perusahaan yang antara lain berupa:",
        child: [
          {
            tag: "7.2.1",
            content: "Pencabutan sertifikasi keagenan; dan/atau",
          },
          {
            tag: "7.2.2",
            content: "Pencantuman pada Daftar Agen Bermasalah.",
          },
        ],
      },
      {
        tag: "7.3",
        content:
          "Pencabutan sertifikasi keagenan dan/atau pencantuman dalam Daftar Agen Bermasalah dapat dilakukan oleh AAJI dalam hal Agen terbukti:",
        child: [
          {
            tag: "7.3.1",
            content:
              "Melakukan kegiatan pemasaran produk asuransi jiwa tanpa memiliki sertifikasi yang sah dan masih berlaku dari AAJI;",
          },
          {
            tag: "7.3.2",
            content: "Melakukan tindak pidana yang terkait dengan usaha perasuransian;",
          },
          {
            tag: "7.3.3",
            content: "Membantu dan/atau memfasilitasi tindak pidana pencucian uang;",
          },
          {
            tag: "7.3.4",
            content: "Melakukan <i>Twisting</i>; atau",
          },
          {
            tag: "7.3.5",
            content: "Melakukan pelanggaran berat lainnya.",
          },
        ],
      },
      {
        tag: "7.4",
        content:
          "Sanksi pencabutan sertifikasi Agen dan sanksi pencantuman dalam Daftar Agen Bermasalah berlaku untuk jangka waktu paling sedikit 5 (lima) tahun.",
      },
    ],
  },
  {
    tag: "8.",
    content: "Pelaksanaan Kode Etik",
    child: [
      {
        tag: "8.1",
        content: "Setiap Agen wajib mematuhi dan tunduk kepada Kode Etik ini.",
      },
      {
        tag: "8.2",
        content:
          "Apabila dianggap perlu oleh Perusahaan, maka Perusahaan berhak untuk mengubah Kode Etik ini setiap saat.",
      },
    ],
  },
];
